/**
 * Canonical names for email-tracking unsubscribe across repos:
 *
 * | Layer | Key / value | Meaning |
 * |-------|-------------|---------|
 * | client-api `unsubscribeSettings` | emailTrackingUnsubscribeOption | GlobalUnsubscribeEmailTracking \| UnsubscribeEmailTrackingTemplate |
 * | client-api | globalEmailTrackingUnsubscribe | Global template id (global site) |
 * | client-api | emailTrackingUnsubscribeTemplate | Site template id |
 * | interaction-proxy | same JSON keys on UnsubscribeSettings | |
 * | template-management `template.type` (stored) | unsubscribeEmailTracking on site id or global site id | Same as marketing `unsubscribe` for pages |
 * | template-management gallery filter | globalUnsubscribeEmailTracking | Parallel to marketing `globalUnsubscribe` |
 *
 * Marketing parallel: unsubscribeOption + globalUnsubscribe / unsubscribeTemplate.
 */

/** LaunchDarkly flag — gates site settings UI, MPS email tracking, and design gallery email-tracking unsubscribes. */
export const LD_EMAIL_TRACKING_CONSENT_FLAG = 'ld-email-tracking-consent';

/** JSON property names on client-api / interaction-proxy `unsubscribeSettings`. */
export const EMAIL_TRACKING_UNSUBSCRIBE_SETTINGS_FIELDS = {
  option: 'emailTrackingUnsubscribeOption',
  globalTemplateId: 'globalEmailTrackingUnsubscribe',
  siteTemplateId: 'emailTrackingUnsubscribeTemplate',
} as const;

/** template-management template.type values (design gallery only). */
export const EMAIL_TRACKING_UNSUBSCRIBE_TEMPLATE_TYPES = {
  /** Passed when creating a global page in MSC; stored as unsubscribeEmailTracking on global site. */
  globalPageCreateType: 'globalUnsubscribeEmailTracking',
  /** Stored template.type for list APIs (global site id or site id). */
  storedPage: 'unsubscribeEmailTracking',
} as const;
